"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Inner = exports.IconContainer = exports.Description = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
        alignItems: 'center',
        textAlign: 'center'
    };
});
const IconContainer = exports.IconContainer = (0, _mui.styled)('div')(()=>({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '9rem',
        justifySelf: 'stretch'
    }));
const Description = exports.Description = (0, _mui.styled)(_mui.Typography)({
    whiteSpace: 'pre-line'
});
